import {
    Box,
    Button,
    ButtonGroup,
    Drawer,
    DrawerBody,
    DrawerCloseButton,
    DrawerContent,
    DrawerHeader,
    DrawerOverlay,
    Flex,
    FormLabel,
    Tab,
    TabList,
    TabPanel,
    TabPanels,
    Tabs,
    useDisclosure,
} from '@chakra-ui/react';
import { Form, Formik, FormikProps } from 'formik';
import React, { useState } from 'react';
import * as Yup from 'yup';

import CustomValidationControl from '../components/CustomValidationControl';

import * as LBCONFIG from '../consts/LeaderboardConfig';

import { ItemDetail, ProductCost, ProductDetail } from '../interfaces/IInventory';

const validationSchema = Yup.object({
    product_name: Yup.string()
        .required('Required')
        .matches(/[a-z0-9-_]+/, 'Invalid'),
});

// const TabInfo = chakra(Box, {
//     baseStyle: {
//         shadow: 'md',
//         rounded: 'md',
//         padding: '3',
//     },
// });

type AddProductFormProps = {
    initialData: ProductDetail;
    items: ItemDetail[];
    onSubmit: any;
    isSaved?: boolean;
};

const AddProductForm: React.FC<AddProductFormProps> = ({
    initialData,
    items,
    onSubmit,
    isSaved = false,
}) => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const helpRef = React.useRef(null);
    const [helperContent, setHelperContent] = useState('');
    const [helperTitle, setHelperTitle] = useState('');

    const itemOptions = items.map((item) => ({
        label: item.item_name,
        value: item.item_id,
    }));

    const openDrawer = (title: string, content: string) => {
        onOpen();

        setHelperContent(content);
        setHelperTitle(title);
    };

    const [step, setStep] = useState(1);

    const handleNextStep = () => {
        setStep(step + 1);
    };

    const handlePrevStep = () => {
        setStep(step - 1);
    };

    const handleTabChange = (index: number) => {
        setStep(index + 1);
    };

    const buildForm = () => {
        return (
            <>
                <Formik
                    onSubmit={(values) => onSubmit(values)}
                    enableReinitialize={true}
                    initialValues={initialData}
                    validationSchema={validationSchema}
                    initialErrors={{}}
                >
                    {(formik: FormikProps<ProductDetail>) => {
                        const createNewCost = () => {
                            const newCost: ProductCost = {
                                cost_type: items.length > 0 ? items[0].item_id : '',
                                quantity: 0,
                            };
                            formik.setValues({
                                ...formik.values,
                                cost: [...(formik.values.cost || []), newCost],
                            });
                        };
                        const createNewItem = () => {
                            // TODO: update so it's not hardcoded anymore
                            const newItem = {
                                item_id: '6196834d-3c86-4bfb-b536-bf1ee821194b:ballstyle_coin',
                                quantity: 1,
                                is_share: false,
                                is_subscription: false,
                                add_on_resubscribe: false,
                                add_to_pool: false,
                                is_unique: false,
                                max_age: null,
                                expire_date: 0,
                                item_def: {
                                    item_id: '6196834d-3c86-4bfb-b536-bf1ee821194b:ballstyle_coin',
                                    item_name: 'Coin',
                                    item_desc: '',
                                    item_type: 'ballstyle',
                                    item_prop: null,
                                    item_owner: '6196834d-3c86-4bfb-b536-bf1ee821194b',
                                    creator_license: [
                                        'd2eea033-f28d-41c6-a992-f85a55c70ab2',
                                        '060d7fac-8605-4302-ace7-845afe8f9625',
                                    ],
                                    creator_user: null,
                                    ttl: 0,
                                },
                            };
                            formik.setValues({
                                ...formik.values,
                                items: [...(formik.values.items || []), newItem],
                            });
                        };
                        return (
                            <>
                                <Box flex={1} border={'1px solid grey'}>
                                    <Box padding={5}>
                                        <Form>
                                            <Tabs index={step - 1} onChange={handleTabChange}>
                                                <TabList>
                                                    <Tab
                                                        backgroundColor={
                                                            formik.errors.product_name
                                                                ? 'red.100'
                                                                : 'transparent'
                                                        }
                                                    >
                                                        Info
                                                    </Tab>
                                                    <Tab>Cost</Tab>
                                                    <Tab>Items</Tab>
                                                </TabList>
                                                <TabPanels>
                                                    <TabPanel>
                                                        <FormLabel>
                                                            Basic information for the product.
                                                        </FormLabel>
                                                        <CustomValidationControl
                                                            name="product_id"
                                                            value={formik.values.product_id}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            label="ID"
                                                            isRequired={true}
                                                            validationMessage={
                                                                formik.touched.product_id &&
                                                                formik.errors.product_id
                                                                    ? formik.errors.product_id
                                                                    : undefined
                                                            }
                                                            help={{
                                                                onClick: () =>
                                                                    openDrawer(
                                                                        'Name',
                                                                        LBCONFIG.HELP_LEADERBOARD_NAME,
                                                                    ),
                                                            }}
                                                            readOnly={isSaved}
                                                        ></CustomValidationControl>
                                                        <CustomValidationControl
                                                            name="product_name"
                                                            value={formik.values.product_name}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            label="Name"
                                                            isRequired={true}
                                                            validationMessage={
                                                                formik.touched.product_name &&
                                                                formik.errors.product_name
                                                                    ? formik.errors.product_name
                                                                    : undefined
                                                            }
                                                            help={{
                                                                onClick: () =>
                                                                    openDrawer(
                                                                        'Name',
                                                                        LBCONFIG.HELP_LEADERBOARD_NAME,
                                                                    ),
                                                            }}
                                                        ></CustomValidationControl>
                                                        <CustomValidationControl
                                                            name="product_desc"
                                                            value={formik.values.product_desc}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            label="Description"
                                                            isRequired={true}
                                                            validationMessage={
                                                                formik.touched.product_desc &&
                                                                formik.errors.product_desc
                                                                    ? formik.errors.product_desc
                                                                    : undefined
                                                            }
                                                            help={{
                                                                onClick: () =>
                                                                    openDrawer(
                                                                        'Name',
                                                                        LBCONFIG.HELP_LEADERBOARD_NAME,
                                                                    ),
                                                            }}
                                                        ></CustomValidationControl>
                                                        <CustomValidationControl
                                                            name="product_type"
                                                            type="select"
                                                            options={[
                                                                {
                                                                    label: 'Real',
                                                                    value: 'real',
                                                                },
                                                                {
                                                                    label: 'Virtual',
                                                                    value: 'virtual',
                                                                },
                                                                {
                                                                    label: 'Reward',
                                                                    value: 'reward',
                                                                },
                                                            ]}
                                                            value={formik.values.product_type}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            label="Type"
                                                            isRequired={true}
                                                            validationMessage={
                                                                formik.touched.product_type &&
                                                                formik.errors.product_type
                                                                    ? formik.errors.product_type
                                                                    : undefined
                                                            }
                                                            help={{
                                                                onClick: () =>
                                                                    openDrawer(
                                                                        'Name',
                                                                        LBCONFIG.HELP_LEADERBOARD_NAME,
                                                                    ),
                                                            }}
                                                        ></CustomValidationControl>
                                                    </TabPanel>
                                                    <TabPanel>
                                                        <FormLabel>
                                                            Items that are required as the cost.
                                                        </FormLabel>
                                                        <Button onClick={createNewCost}>+</Button>
                                                        {formik.values.cost?.map((item, i) => (
                                                            <Box
                                                                key={`cost_${i}`}
                                                                border="1px solid black"
                                                                borderRadius={'0.25em'}
                                                                padding="1em"
                                                            >
                                                                <CustomValidationControl
                                                                    name={`cost[${i}].cost_type`}
                                                                    type="select"
                                                                    options={itemOptions}
                                                                    value={item.cost_type}
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                    label="Type"
                                                                    isRequired={true}
                                                                    validationMessage={
                                                                        formik.touched.cost &&
                                                                        formik.errors.cost
                                                                            ? formik.errors.cost
                                                                            : undefined
                                                                    }
                                                                    help={{
                                                                        onClick: () =>
                                                                            openDrawer(
                                                                                'Name',
                                                                                LBCONFIG.HELP_LEADERBOARD_NAME,
                                                                            ),
                                                                    }}
                                                                ></CustomValidationControl>
                                                                <CustomValidationControl
                                                                    name={`cost[${i}].quantity`}
                                                                    value={item.quantity}
                                                                    onChange={(num) => {
                                                                        formik.setFieldValue(
                                                                            `cost[${i}].quantity`,
                                                                            Number(num),
                                                                        );
                                                                    }}
                                                                    onBlur={formik.handleBlur}
                                                                    label="Quantity"
                                                                    type="number"
                                                                    isRequired={true}
                                                                    validationMessage={
                                                                        formik.touched.cost &&
                                                                        formik.errors.cost
                                                                            ? formik.errors.cost
                                                                            : undefined
                                                                    }
                                                                    help={{
                                                                        onClick: () =>
                                                                            openDrawer(
                                                                                'Name',
                                                                                LBCONFIG.HELP_LEADERBOARD_NAME,
                                                                            ),
                                                                    }}
                                                                ></CustomValidationControl>
                                                            </Box>
                                                        ))}
                                                    </TabPanel>
                                                    <TabPanel>
                                                        <FormLabel>
                                                            Items that are included in the product.
                                                        </FormLabel>
                                                        <Button onClick={createNewItem}>+</Button>
                                                        {formik.values.items?.map((item, i) => (
                                                            <Box
                                                                key={`item_${i}`}
                                                                border="1px solid black"
                                                                borderRadius={'0.25em'}
                                                                padding="1em"
                                                            >
                                                                <CustomValidationControl
                                                                    name={`items[${i}].item_id`}
                                                                    type="select"
                                                                    options={itemOptions}
                                                                    value={item.item_id}
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                    label="Item ID"
                                                                    isRequired={true}
                                                                    // validationMessage={
                                                                    //     formik
                                                                    //         .touched
                                                                    //         .items &&
                                                                    //         formik
                                                                    //         .touched
                                                                    //         .items[i].item_id &&
                                                                    //     formik
                                                                    //         .errors
                                                                    //         .items && formik
                                                                    //         .errors
                                                                    //         .items[i]
                                                                    //         ? formik
                                                                    //               .errors
                                                                    //               .items[i]
                                                                    //         : undefined
                                                                    // }
                                                                    help={{
                                                                        onClick: () =>
                                                                            openDrawer(
                                                                                'Name',
                                                                                LBCONFIG.HELP_LEADERBOARD_NAME,
                                                                            ),
                                                                    }}
                                                                ></CustomValidationControl>
                                                                <CustomValidationControl
                                                                    name={`items[${i}].quantity`}
                                                                    value={item.quantity}
                                                                    onChange={(num) => {
                                                                        formik.setFieldValue(
                                                                            `items[${i}].quantity`,
                                                                            Number(num),
                                                                        );
                                                                    }}
                                                                    onBlur={formik.handleBlur}
                                                                    label="Quantity"
                                                                    type="number"
                                                                    isRequired={true}
                                                                    // validationMessage={
                                                                    //     formik
                                                                    //         .touched
                                                                    //         .items &&
                                                                    //     formik
                                                                    //         .errors
                                                                    //         .items
                                                                    //         ? formik
                                                                    //               .errors
                                                                    //               .items
                                                                    //         : undefined
                                                                    // }
                                                                    help={{
                                                                        onClick: () =>
                                                                            openDrawer(
                                                                                'Name',
                                                                                LBCONFIG.HELP_LEADERBOARD_NAME,
                                                                            ),
                                                                    }}
                                                                ></CustomValidationControl>
                                                                <CustomValidationControl
                                                                    name={`items[${i}].add_on_resubscribe`}
                                                                    value={item.add_on_resubscribe}
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                    label="Add on Resubscribe?"
                                                                    type="checkbox"
                                                                    isRequired={false}
                                                                    // validationMessage={
                                                                    //     formik
                                                                    //         .touched
                                                                    //         .items &&
                                                                    //     formik
                                                                    //         .errors
                                                                    //         .items
                                                                    //         ? formik
                                                                    //               .errors
                                                                    //               .items
                                                                    //         : undefined
                                                                    // }
                                                                    help={{
                                                                        onClick: () =>
                                                                            openDrawer(
                                                                                'Name',
                                                                                LBCONFIG.HELP_LEADERBOARD_NAME,
                                                                            ),
                                                                    }}
                                                                ></CustomValidationControl>
                                                            </Box>
                                                        ))}
                                                    </TabPanel>
                                                </TabPanels>
                                            </Tabs>
                                            <Flex justifyContent={'space-between'} mt={5}>
                                                <ButtonGroup>
                                                    <Button
                                                        onClick={handlePrevStep}
                                                        disabled={step === 1}
                                                        data-cy="previous-step"
                                                    >
                                                        Previous
                                                    </Button>
                                                    <Button
                                                        onClick={handleNextStep}
                                                        disabled={step === 3}
                                                        data-cy="next-step"
                                                    >
                                                        Next
                                                    </Button>
                                                </ButtonGroup>
                                                <ButtonGroup>
                                                    <Button type="submit">Save</Button>
                                                </ButtonGroup>
                                            </Flex>
                                        </Form>
                                    </Box>
                                </Box>
                                {/* <Box flex={1}>
                                    {
                                        <JSONPreview
                                            data={formik.values}
                                            caption={'Product JSON:'}
                                            clampHeight={true}
                                        />
                                    }
                                </Box> */}
                            </>
                        );
                    }}
                </Formik>
                <Drawer isOpen={isOpen} placement="right" onClose={onClose} finalFocusRef={helpRef}>
                    <DrawerOverlay />
                    <DrawerContent>
                        <DrawerCloseButton />
                        <DrawerHeader>{helperTitle}</DrawerHeader>

                        <DrawerBody whiteSpace="pre-wrap">{helperContent}</DrawerBody>
                    </DrawerContent>
                </Drawer>
            </>
        );
    };

    return buildForm();
};

export default AddProductForm;
